"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContainer = exports.StyledColorDot = exports.StyledColorsBox = exports.StyledColorsBoxContainer = exports.StyledDropdownBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledDropdownBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledDropdownBox",
  componentId: "sc-1pu87mr-0"
})(["flex:0 0 30%;"]);

exports.StyledDropdownBox = StyledDropdownBox;

var StyledColorsBoxContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledColorsBoxContainer",
  componentId: "sc-1pu87mr-1"
})(["flex:0 0 70%;", " ", ""], function (props) {
  return props.alignCenter && (0, _styledComponents.css)(["align-items:center;display:flex;"]);
}, function (props) {
  return props.overflowIsHidden && (0, _styledComponents.css)(["max-height:70px;overflow-y:scroll;"]);
});

exports.StyledColorsBoxContainer = StyledColorsBoxContainer;

var StyledColorsBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledColorsBox",
  componentId: "sc-1pu87mr-2"
})(["display:flex;align-items:center;font-size:14px;color:#717171;", ""], function (props) {
  return props.alignCenter && (0, _styledComponents.css)(["float:left;width:110px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin:5px;padding-left:20px;position:relative;> span{position:absolute;left:0;}"]);
});

exports.StyledColorsBox = StyledColorsBox;

var StyledColorDot = _styledComponents["default"].span.withConfig({
  displayName: "style__StyledColorDot",
  componentId: "sc-1pu87mr-3"
})(["", " width:14px;height:14px;display:block;border-radius:14px;margin:0 5px 0 0;"], function (props) {
  return props.color && (0, _styledComponents.css)(["background:", ";"], props.color);
});

exports.StyledColorDot = StyledColorDot;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledContainer",
  componentId: "sc-1pu87mr-4"
})(["display:flex;justify-content:space-between;box-sizing:border-box;border-top:1px solid #d7d7d7;width:100%;min-height:55px;padding:15px 36px;*{box-sizing:border-box;outline:0;}"]);

exports.StyledContainer = StyledContainer;